import { TF } from "react-translator-component";
import { isGemunder, isHostz, isHostzBlackSummit, isOffgrid } from "../components/CheckIn/hotelConditions";

const checkinTimes = {
    "8fcf8b78-ed33-4575-b00a-4c8be2886ce0": "16",//KL
    "511e8df9-672d-42b1-9711-d82beb7baf64": "14",//DEV MATIAS
    "fea1efb3-9d97-4374-ab72-109bda0a9819": "16",//BKR
    "4c126315-cf81-4e93-93fb-57ca1b07d220": "16",//BKR
    "de6a6244-3a0c-44fb-b1e8-53f38d94019a": "16",//BKR
    "e2ba6052-9f7f-4213-93a7-094317fc722f": "16",//BKR
    "cf9b040e-bcf6-4d55-adbb-9fc705183e9c": "16"//BKR
};
const checkinTimesHostz = {
    "d4676e50-71ed-4c01-bcdf-84b2b55b1890": "17hs.", //BS Hostz
    "b2501a57-ef47-445a-99fb-05324a4eb7e6": "17hs.", // black-summit
    "9983de2a-9f3e-4c75-9fb9-62e9855681e8": "16hs.", //Becozy
    "b58142a6-dfbc-4b7a-ab7e-8bac3e848b51": "14hs.", //San Carlo 
    "af8e44a0-c64c-4647-bb12-abd0af4b4a4b": "4 pm",     // Arosa
    "b09e49f0-d0ac-4723-ac65-8cce7aba74c8": "16hs.",     // swissstay
    "42b8cd5a-0aa8-407b-b9d8-c2f2b7e2b6cc": "15hs."     // Steiners
}

export const GetCheckinTime = ({ hotelId }) => {
    return (
        <p className="general-text-sm text-center mt-2">
            {isHostz(hotelId) && TF("checkin.time-of-arrival-text2-hostz", [checkinTimesHostz[hotelId] || "5:00 p.m."])}
            {isOffgrid(hotelId) && TF("checkin.time-of-arrival-text2-offgrid", [checkinTimes[hotelId] || "15"])}
            {!isHostz(hotelId) && !isOffgrid(hotelId) && TF("checkin.time-of-arrival-text2", [checkinTimes[hotelId] || "15"])}
        </p>
    )
}

// export const GetCheckOutTime = ({ hotelId }) => {
//     return (
//         <p className="general-text-sm text-center mt-2">
//             {TF("checkin.time-of-departure-text2", [checkinTimes[hotelId] || "15"])}
//         </p>
//     )
// }
